<template>
  <div class="ml-5 mr-5  rich-text-wrapper">
    <v-row class="justify-center">
      <v-col cols="12">
        <v-card class="card-text text-center">
          <!-- editor  -->
          <v-row justify="center">
            <quillEditor
              class="rich-text-wrapper__editor"
              :content="resource.description"
              :options="editorOption"
              :disabled="true"
            />
          </v-row>

        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { mapActions } from 'vuex';
export default {
  props: ["resource"],
  name: "RomaText",
  data() {
    return {
      editorOption: {
        readOnly: true,
        modules: {
          toolbar: false,
        },
        placeholder: ''
      },
    };
  },
  components: {
    quillEditor,
  },

  // mounted() {
  //   this.actionClickOnResource({ resourceId: this.resource.resourcesId, activityId: this.resource.activity.activityLessonId});
  // },

  // methods: {
  //   ...mapActions({
  //     actionClickOnResource: "actionClickOnResource"
  //   })
  // }
};

export class RomaText {}
</script>

<style lang="scss">
.rich-text-wrapper {
  height: 100%;
    .row{
        height: 100%;
        .col{
            height: 100%;
            .v-card{
                 height: 100%;

            }
        }
    }
  .card-text {
    background: #ffffff 0 0 no-repeat padding-box;
    box-shadow: 0 6px 6px #0000001c;
    // border-radius: 10px;
    padding: 3% 0 5% 0;
  }
  &__editor {
    // background-color: #bada55;
    .ql-container.ql-snow {
      border: 0;
    }

    .ql-editor {
        word-break: normal;
        padding: 2rem;
    }
  }
}
</style>
